<div class="mySubscriptionPage">
  <div class="row">
    <div class="col-12 padding-l20 pagingArea margin-b10 margin-t5">

      <div class="display-ib wAuto">
        <mat-checkbox [color]="'primary'" [checked]="isTopLevelCheckboxClicked" (change)="selectAllLevels($event.checked)" [indeterminate]="anyLevelChecked()" class="example-margin"></mat-checkbox>
        <span class="manage-subs margin-l20" *ngIf="showHideGlobalSubscription()" (click)="openGlobalSubscriptionDialog()" [ngClass]="!canShowGlobalSub ? 'disabled-span':''" [matTooltip]="!canShowGlobalSub ? 'No Account available':''" [matTooltipPosition]="'right'" matTooltipClass="greyBgCpp">
          <i class="fa fa-envelope" aria-hidden="true"></i>
        </span>
      </div>
    </div>
    <div *ngIf="groupBy == 'userId' && groupByUserIdDS" class="tableContainer mySubscription">
      <table mat-table #mySubscriptionTable [dataSource]="groupByUserIdDS" multiTemplateDataRows matSort matSortDirection="desc" class="matTables">
        <ng-container matColumnDef="users">
          <th mat-header-cell *matHeaderCellDef mat-sort-header class="text-center heading hide-mat-sort">USERS</th>
          <td mat-cell *matCellDef="let user" class="text-left">

            <div class="text-center">
              <span><i (click)="onPushPinClick(user)" [ngClass]="user.isPushPinClicked ? 'pinChecked':'pinUnchecked'" class="fas fa-light fa-thumbtack" *ngIf="user.isFirstLevelExpanded"></i></span>
              <span><i (click)="toggleFirstLevelRow(user)" [ngClass]="user.isFirstLevelExpanded ? 'dropdownArrowOpen':'dropdownArrowClose'" class="fas fa-sort-down"></i></span>
              <span class="margin-l30 align-bottom">
                <mat-checkbox [color]="'primary'" [checked]="user.isChecked" (change)="onCheckboxChange($event.checked,user)" [indeterminate]="someFirstLevelComplete(user)" class="example-margin"></mat-checkbox>
              </span>
            </div>
          </td>
        </ng-container>
        <ng-container matColumnDef="userName">
          <th mat-header-cell *matHeaderCellDef mat-sort-header class="text-center heading2 hide-mat-sort">USER NAME</th>
          <td mat-cell *matCellDef="let user" class="text-left"> {{user.userName}} </td>
        </ng-container>
        <ng-container matColumnDef="userID">
          <th mat-header-cell *matHeaderCellDef mat-sort-header class="text-center heading3 hide-mat-sort">USER ID</th>
          <td mat-cell *matCellDef="let user" class="text-left"> {{user.userID}} </td>
        </ng-container>
        <ng-container matColumnDef="emailAddress">
          <th mat-header-cell *matHeaderCellDef mat-sort-header class="text-center heading4 hide-mat-sort">EMAIL</th>
          <td mat-cell *matCellDef="let user" class="text-left"> {{user.emailAddress}} </td>
        </ng-container>
        <ng-container matColumnDef="userRole">
          <th mat-header-cell *matHeaderCellDef mat-sort-header class="text-center heading5 hide-mat-sort">USER ROLE</th>
          <td mat-cell *matCellDef="let user" class="text-left"> {{user.userRole}} </td>
        </ng-container>

        <!-- Expanded Content Column - The detail row is made up of this one column that spans across all columns -->
        <ng-container matColumnDef="expandedDetail">
          <td class="padding-0" mat-cell *matCellDef="let user" [attr.colspan]="groupByUserIdColumns.length" [ngStyle]="user.isFirstLevelExpanded ? '':{'display': 'none'}">
            <div class="example-element-detail" [ngClass]="user.isPushPinClicked ? 'setHeight':''"
                 [@detailExpand]="user && user.isFirstLevelExpanded ? 'expanded' : 'collapsed'" [ngStyle]="user.isPushPinClicked ? '' : {'overflow': 'hidden'}">
              <table class="detail-table">
                <tr [ngClass]="user.isPushPinClicked ? 'addStickyClass':''">
                  <th>Accounts</th>
                  <th>Account</th>
                  <th>Account Name</th>
                  <th>Address</th>
                  <th>City</th>
                  <th>State/Province</th>
                </tr>
                <div class="each-row" *ngFor="let account of user.mySubscriptionAccountsVM">
                <tr (mouseover)="onHover(user.userID)" (mouseout)="onHover('')">
                  <td class="text-center">
                    <span>
                      <i (click)="EditSubscriptions(account,user)" class="fas fa-edit editIcon"></i>
                    </span>
                    <span class="margin-l30 align-bottom">
                      <mat-checkbox [color]="'primary'" [checked]="account.isChecked" (change)="onSecondLevelCheckboxChange($event.checked,account,user)" class="example-margin"></mat-checkbox>
                    </span>
                  </td>
                  <td>{{account.accountNumber}}</td>
                  <td><span *ngIf="account.isFavouriteChecked== true &&  account.isFavouriteOptionAvailable == true"><i class="fas fa-solid fa-star"></i></span>{{account.accountName}}</td>
                  <td>{{account.address}}</td>
                  <td>{{account.city}}</td>
                  <td>{{account.state}}</td>
                </tr>
            </div>
      </table>
    </div>
    </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="groupByUserIdColumns;sticky:true;"></tr>
    <tr mat-row *matRowDef="let row; columns: groupByUserIdColumns;" class="example-element-row"
        [class.example-expanded-row]="user && user.isFirstLevelExpanded" [ngClass]="(row && row.isPushPinClicked) || (row && parentRowUserId==row.userID) ? 'addBlueBg':''"></tr>
    <tr mat-row *matRowDef="let row; columns: ['expandedDetail']" class="example-detail-row"></tr>
    </table>
  </div>

  <div *ngIf="groupBy == 'accounts' && groupByAccountsDS" class="tableContainer mySubscription">
    <table mat-table #mySubscriptionTableByAccount [dataSource]="groupByAccountsDS" matSort multiTemplateDataRows matSortDirection="desc" class="matTables">
      <ng-container matColumnDef="accounts">
        <th mat-header-cell *matHeaderCellDef mat-sort-header class="text-center heading">ACCOUNTS</th>
        <td mat-cell *matCellDef="let account" class="text-left">
          <div class="text-center">
            <span><i (click)="onPushPinClick(account)" [ngClass]="account.isPushPinClicked ? 'pinChecked':'pinUnchecked'" class="fas fa-light fa-thumbtack" *ngIf="account.isFirstLevelExpanded"></i></span>
            <span><i (click)="toggleFirstLevelRow(account)" [ngClass]="account.isFirstLevelExpanded ? 'dropdownArrowOpen':'dropdownArrowClose'" class="fas fa-sort-down"></i></span>
            <span class="margin-l30 align-bottom">
              <mat-checkbox [color]="'primary'" [checked]="account.isChecked" (change)="onCheckboxChange($event.checked,account)" [indeterminate]="someFirstLevelComplete(account)" class="example-margin"></mat-checkbox>
            </span>
          </div>
        </td>
      </ng-container>
      <ng-container matColumnDef="accountNumber">
        <th mat-header-cell *matHeaderCellDef mat-sort-header class="text-center heading2">ACCOUNT</th>
        <td mat-cell *matCellDef="let account" class="text-left"> {{account.accountNumber}} </td>
      </ng-container>
      <ng-container matColumnDef="accountName">
        <th mat-header-cell *matHeaderCellDef mat-sort-header class="text-center heading3">ACCOUNT NAME</th>
        <td mat-cell *matCellDef="let account" class="text-left"><span *ngIf="account.isFavouriteChecked== true && account.isFavouriteOptionAvailable== true"><i class="fas fa-solid fa-star"></i></span> {{account.accountName}} </td>
      </ng-container>
      <ng-container matColumnDef="address">
        <th mat-header-cell *matHeaderCellDef mat-sort-header class="text-center heading4">ADDRESS</th>
        <td mat-cell *matCellDef="let account" class="text-left"> {{account.address}} </td>
      </ng-container>
      <ng-container matColumnDef="city">
        <th mat-header-cell *matHeaderCellDef mat-sort-header class="text-center heading5">CITY</th>
        <td mat-cell *matCellDef="let account" class="text-left"> {{account.city}} </td>
      </ng-container>
      <ng-container matColumnDef="state">
        <th mat-header-cell *matHeaderCellDef mat-sort-header class="text-center heading5">STATE/PROVINCE</th>
        <td mat-cell *matCellDef="let account" class="text-left"> {{account.state}} </td>
      </ng-container>

      <!-- Expanded Content Column - The detail row is made up of this one column that spans across all columns -->
      <ng-container matColumnDef="expandedDetail">
        <td class="padding-0" mat-cell *matCellDef="let account" [attr.colspan]="groupByAccountsColumns.length" [ngStyle]="account.isFirstLevelExpanded ? '':{'display': 'none'}">
          <div class="example-element-row" [ngClass]="account.isPushPinClicked && account.mySubscriptionAccountUserVM.length > 1 ? 'setHeightAccountsTab':''"
               [@detailExpand]="account && account.isFirstLevelExpanded ? 'expanded' : 'collapsed'" [ngStyle]="account.isPushPinClicked ? '' : {'overflow': 'hidden'}">
            <table class="detail-table">
              <tr [ngClass]="account.isPushPinClicked ? 'addStickyClass':''">
                <th>USERS</th>
                <th>USER NAME</th>
                <th>USER ID</th>
                <th>EMAIL</th>
                <th>USER ROLE</th>
              </tr>
              <div class="each-row" *ngFor="let user of account.mySubscriptionAccountUserVM">
              <tr (mouseover)="onHover(account.accountNumber)" (mouseout)="onHover('')">
                <td class="text-center">
                  <span>
                    <i (click)="EditSubscriptions(account,user)" class="fas fa-edit editIcon"></i>
                  </span>
                  <span class="margin-l30 align-bottom">
                    <mat-checkbox [color]="'primary'" [checked]="user.isChecked" (change)="onSecondLevelCheckboxChange($event.checked,account,user)" class="example-margin"></mat-checkbox>
                  </span>
                </td>
                <td>{{user.userName}}</td>
                <td>{{user.userID}}</td>
                <td>{{user.emailAddress}}</td>
                <td>{{user.userRole}}</td>
              </tr>
          </div>
    </table>
  </div>
  </td>
  </ng-container>
  <tr mat-header-row *matHeaderRowDef="groupByAccountsColumns; sticky:true;"></tr>
  <tr mat-row *matRowDef="let row; columns: groupByAccountsColumns;" class="example-element-row"
      [class.example-expanded-row]="account && account.isFirstLevelExpanded" [ngClass]="(row && row.isPushPinClicked) || (row && parentRowUserId==row.accountNumber) ? 'addBlueBg':''"></tr>
  <tr mat-row *matRowDef="let row; columns: ['expandedDetail']" class="example-detail-row"></tr>
  </table>
</div>
</div>
